import { render, staticRenderFns } from "./SupportTicketCard.vue?vue&type=template&id=4db2966c&scoped=true&"
import script from "./SupportTicketCard.vue?vue&type=script&lang=js&"
export * from "./SupportTicketCard.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketCard.vue?vue&type=style&index=0&id=4db2966c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2966c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
